import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KE_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#KE_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#4E8B1D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M0 7h-1v10h34V7H0z",
      fill: "#E31D1C",
      stroke: "#F7FCFF",
      strokeWidth: 2
    }
  )),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.02 3.929c.19-.39.703-.817 1.535-1.279a.1.1 0 01.139.132l-8.631 17.697-.45-.22 7.609-15.6c-.345-.055-.412-.299-.202-.73z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.97 3.929c.211.431.144.675-.2.73l7.608 15.6-.45.22-8.63-17.697a.1.1 0 01.138-.132c.833.462 1.345.888 1.535 1.279z",
      fill: "#fff"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 20c.997 0 5-3.582 5-8s-4.003-8-5-8c-.997 0-5 3.582-5 8s4.003 8 5 8z",
      fill: "#E31D1C"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KE_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 11,
      y: 4,
      width: 10,
      height: 16
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 20c.997 0 5-3.582 5-8s-4.003-8-5-8c-.997 0-5 3.582-5 8s4.003 8 5 8z",
        fill: "#fff"
      }
    )
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#KE_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.5 19a7 7 0 100-14 7 7 0 000 14zM25.5 19a7 7 0 100-14 7 7 0 000 14z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.2 10.93c.456-.324.8-1.737.8-3.431s-.344-3.107-.8-3.43v6.86zm-.5-.092c-.406-.447-.7-1.773-.7-3.34 0-1.565.294-2.891.7-3.338v6.678zm0 2.322v6.678c-.406-.447-.7-1.773-.7-3.34 0-1.565.294-2.891.7-3.338zm.5 6.77v-6.862c.456.324.8 1.737.8 3.43 0 1.695-.344 3.108-.8 3.431z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M16 11a1 1 0 110 2 1 1 0 010-2z", fill: "#F7FCFF" }))
), a = t;
export {
  a as default
};
